import { render, staticRenderFns } from "./RepairExtensionMailLawyer.vue?vue&type=template&id=005565b1&scoped=true"
import script from "./RepairExtensionMailLawyer.vue?vue&type=script&lang=js"
export * from "./RepairExtensionMailLawyer.vue?vue&type=script&lang=js"
import style0 from "./RepairExtensionMailLawyer.vue?vue&type=style&index=0&id=005565b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005565b1",
  null
  
)

export default component.exports